document.addEventListener("DOMContentLoaded", function() {

  function isProductAddForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    const action = (form.getAttribute('action') || '').toLowerCase();
    return form.classList.contains('product-form') ||
      form.classList.contains('shopify-product-form') ||
      action.indexOf('/cart/add') !== -1;
  }

  function getSelectedVariantId(form) {
    const idInput = form.querySelector('[name="variant-choice"]:checked') || form.querySelector('[name="id"]');
    return idInput ? parseInt(idInput.value, 10) : null;
  }

  function getSelectedVariant(form) {
    const id = getSelectedVariantId(form);
    if (!id || !window.CartEngine || typeof window.CartEngine.getProductVariantById !== 'function') {
      return null;
    }
    return window.CartEngine.getProductVariantById(id);
  }

  function syncProductQtyLimits(form) {
    if (!form) return;
    const qtyInput = form.querySelector('.quantity-input');
    const btnMinus = form.querySelector('.btn-qty-min');
    const btnPlus = form.querySelector('.btn-qty-plus');
    const submitBtns = form.querySelectorAll('.btn-add-to-cart');
    const qtyContent = form.querySelector('.product-quantity-content');
    const paymentBtns = form.querySelectorAll('.shopify-payment-button-wrapper');

    if (!window.CartEngine) return;
    const variant = getSelectedVariant(form);
    
    const isAvailable = variant ? variant.available : false;
    const firstBtn = submitBtns[0] || null;
    const defaultText = (firstBtn && firstBtn.getAttribute('data-default')) || 'Add to Cart';
    const soldOutText = (firstBtn && firstBtn.getAttribute('data-sold-out')) || 'Sold Out';

    // Apply the disabled / text / sold-out state to EVERY .btn-add-to-cart inside
    // the form (the desktop button AND the mobile .bottom-action-bar button) so a
    // variant change disables/enables them all consistently.
    function setAddToCartState(disabled, text, soldOut) {
      submitBtns.forEach(function(btn) {
        if (!btn) return;
        // The mobile sticky bottom bar keeps its cart icon: only toggle the
        // disabled attribute and .is-soldout class, never overwrite its content.
        const isBottomBar = btn.closest('.bottom-action-bar');
        if (text !== null && !isBottomBar) btn.textContent = text;
        btn.disabled = disabled;
        btn.classList.toggle('is-soldout', Boolean(soldOut));
      });
    }

    // Show/hide every dynamic checkout (.shopify-payment-button-wrapper) in the form.
    function setPaymentVisible(visible) {
      paymentBtns.forEach(function(wrap) {
        if (wrap) wrap.style.display = visible ? '' : 'none';
      });
    }

    if (!isAvailable) {
      if (qtyInput) {
        qtyInput.value = 1;
        qtyInput.disabled = true;
      }
      if (btnMinus) btnMinus.disabled = true;
      if (btnPlus) btnPlus.disabled = true;
      if (qtyContent) {
        qtyContent.classList.add('is-disabled');
      }
      setAddToCartState(true, soldOutText, true);
      setPaymentVisible(false);
      // return;
    }

    if (qtyInput) qtyInput.disabled = false;
    if (btnMinus) btnMinus.disabled = false;
    if (qtyContent) {
      qtyContent.classList.remove('is-disabled');
    }
    setPaymentVisible(true);

    // Update hidden inputs so FormData picks up the correct variant ID
    if (variant) {
      form.querySelectorAll('input[type="hidden"][name="id"]').forEach(function(hidden) {
        if (hidden.value !== String(variant.id)) {
          hidden.value = variant.id;
          hidden.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    // Update URL if this is the main product page
    if (variant && window.history && window.history.replaceState) {
      if (!form.closest('.kg-pcard') && !form.closest('.qz-pcard')) {
        const url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }

    // Update Price dynamically
    if (variant) {
      const formatMoney = function(cents, hasSpace) {
        if (!cents) return '';
        let value = (cents / 100).toString();
        value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        return (hasSpace ? 'Rp ' : 'Rp') + value;
      };

      const priceWrapper = form.closest('.product-detail, .kg-pcard__body') || document;
      const priceEl = priceWrapper.querySelector('.product-price, .kg-pcard__price, .price--regular');
      const compareEl = priceWrapper.querySelector('.product-compare-price, .kg-pcard__orig');
      
      const compareWrapper = priceWrapper.querySelector('.product-compare-wrapper');
      const discountEl = priceWrapper.querySelector('.product-discount-badge');

      const isDiscounted = Boolean(variant.compare_at_price && variant.compare_at_price > variant.price);

      if (priceEl && variant.price) {
        const hasSpace = !priceEl.classList.contains('price--regular');
        priceEl.innerHTML = formatMoney(variant.price, hasSpace);
        priceEl.classList.toggle('price--discounted', isDiscounted);
        if (priceEl.classList.contains('kg-pcard__price')) {
          priceEl.classList.toggle('kg-pcard__price--discounted', isDiscounted);
        }
      }
      if (compareEl) {
        const hasSpace = !compareEl.classList.contains('price--regular');
        if (isDiscounted) {
          compareEl.innerHTML = formatMoney(variant.compare_at_price, hasSpace);
          compareEl.style.visibility = 'visible';
          compareEl.style.opacity = '1';
          if (compareWrapper) compareWrapper.style.display = 'inline-flex';
          if (discountEl) {
            const disc = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
            discountEl.textContent = `-${disc}%`;
          }
        } else {
          compareEl.style.visibility = 'hidden';
          compareEl.style.opacity = '0';
          if (compareWrapper) compareWrapper.style.display = 'none';
        }
      }
    }

    // Update active slide in the slick carousel
    if (variant && variant.featured_image && variant.featured_image.id) {
      const targetImageId = variant.featured_image.id;
      const mainSlider = document.querySelector('.product-images-slider');
      if (mainSlider && window.jQuery && window.jQuery.fn.slick) {
        const $main = window.jQuery(mainSlider);
        if ($main.hasClass('slick-initialized')) {
          let slideIndex = -1;
          mainSlider.querySelectorAll('.slick-slide:not(.slick-cloned)').forEach(function(slide, idx) {
            const imgWrapper = slide.querySelector('[data-image-id]');
            if (imgWrapper && String(imgWrapper.getAttribute('data-image-id')) === String(targetImageId)) {
              slideIndex = idx;
            }
          });
          if (slideIndex !== -1) {
            $main.slick('slickGoTo', slideIndex, false);
            
            const thumbSlider = document.querySelector('.product-thumbnail-slider');
            if (thumbSlider) {
              const $thumb = window.jQuery(thumbSlider);
              if ($thumb.hasClass('slick-initialized')) {
                $thumb.slick('slickGoTo', slideIndex, false);
              }
            }
          }
        }
      }
    }

    const maxAdd = window.CartEngine.getMaxAddableQty(variant);

    if (maxAdd <= 0) {
      if (qtyInput) {
        qtyInput.value = 1;
        qtyInput.max = 1;
      }
      if (btnPlus) btnPlus.disabled = true;
      setAddToCartState(true, 'Sold Out', true);
      return;
    }

    setAddToCartState(false, defaultText, false);
    if (qtyInput) {
      qtyInput.max = maxAdd;
      qtyInput.min = 1;
      let value = parseInt(qtyInput.value, 10) || 1;
      if (value > maxAdd) { qtyInput.value = maxAdd; value = maxAdd; }
      if (value < 1) qtyInput.value = 1;
      if (btnPlus) btnPlus.disabled = value >= maxAdd;
    }
  }

  function initProductForm(form) {
    if (form.dataset.initialized) return;
    form.dataset.initialized = "true";

    const qtyInput = form.querySelector('.quantity-input');
    const btnMinus = form.querySelector('.btn-qty-min');
    const btnPlus = form.querySelector('.btn-qty-plus');

    if (btnMinus && qtyInput) {
      btnMinus.addEventListener('click', function() {
        if (btnMinus.disabled) return;
        let value = parseInt(qtyInput.value, 10) || 1;
        if (value > 1) {
          qtyInput.value = value - 1;
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        syncProductQtyLimits(form);
      });
    }

    if (btnPlus && qtyInput) {
      btnPlus.addEventListener('click', function() {
        if (btnPlus.disabled) return;
        const variant = getSelectedVariant(form);
        const maxAdd = window.CartEngine ? window.CartEngine.getMaxAddableQty(variant) : 9999;
        let value = parseInt(qtyInput.value, 10) || 1;
        if (value < maxAdd) {
          qtyInput.value = value + 1;
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        syncProductQtyLimits(form);
      });
    }

    if (qtyInput) {
      qtyInput.addEventListener('change', function() {
        syncProductQtyLimits(form);
      });
    }

    form.querySelectorAll('.variant-radio, [name="variant-choice"], [name="id"]').forEach(function(el) {
      el.addEventListener('change', function() {
        syncProductQtyLimits(form);
      });
    });

    syncProductQtyLimits(form);
  }

  function syncAllForms() {
    document.querySelectorAll('form').forEach(function(form) {
      if (isProductAddForm(form)) {
        syncProductQtyLimits(form);
      }
    });
  }

  window.syncProductQtyLimits = syncAllForms; // Expose globally for cart update callback

  document.querySelectorAll('form').forEach(function(form) {
    if (isProductAddForm(form)) {
      initProductForm(form);
    }
  });

  function handleProductAddToCart(form) {
    const addToCartBtns = form.querySelectorAll('.btn-add-to-cart');
    const btn = addToCartBtns[0] || null;
    var T = window.GentlyTranslations || {};
    var addingText = (btn && btn.getAttribute('data-adding')) || T.adding || 'Adding...';
    var defaultText = (btn && btn.getAttribute('data-default')) || T.addToCart || 'Add to Cart';
    addToCartBtns.forEach(function(b) {
      // Keep the mobile sticky bottom bar's cart icon; only toggle its state.
      if (!b.closest('.bottom-action-bar')) {
        b.textContent = addingText;
      }
      b.disabled = true;
    });

    const resetBtn = function() {
      addToCartBtns.forEach(function(b) {
        if (!b.closest('.bottom-action-bar')) {
          b.textContent = defaultText;
        }
        b.disabled = false;
      });
      syncProductQtyLimits(form);
    };

    if (!window.CartEngine || typeof window.CartEngine.addFromForm !== 'function') {
      console.error('CartEngine belum dimuat.');
      alert('Keranjang belum siap. Silakan muat ulang halaman.');
      resetBtn();
      return;
    }

    // CHECK FOR VARIANT SELECTOR POPUP LOGIC
    const pCard = form.closest('.kg-pcard, .qz-pcard');
    if (pCard) {
      const jsonScript = pCard.querySelector('.pcard-product-json');
      if (jsonScript) {
        try {
          const productData = JSON.parse(jsonScript.textContent);
          if (productData && productData.has_only_default_variant === false) {
            if (typeof window.CartEngine.showVariantSelector === 'function') {
              resetBtn();
              window.CartEngine.showVariantSelector(productData, form);
              return;
            }
          }
        } catch (e) {
          console.error("Failed to parse product variants json", e);
        }
      }
    }

    const variantId = getSelectedVariantId(form);
    const variant = (variantId && window.CartEngine.getProductVariantById)
      ? window.CartEngine.getProductVariantById(variantId)
      : null;

    if (variantId) {
      form.querySelectorAll('input[type="hidden"][name="id"]').forEach(function(hidden) {
        hidden.value = variantId;
      });
    }

    const qtyEl = form.querySelector('.quantity-input') || form.querySelector('[name="quantity"]');
    const requestedQty = parseInt(qtyEl && qtyEl.value, 10) || 1;

    window.CartEngine.fetchCartJson().then(function() {
      if (window.CartEngine.getVariantStockCap(variant) !== null && requestedQty > window.CartEngine.getMaxAddableQty(variant)) {
        window.CartEngine.showAddToCartError(
          window.CartEngine.buildStockLimitMessage(variant, window.CartEngine.getMaxAddableQty(variant))
        );
        throw { handled: true };
      }
      return window.CartEngine.addFromForm(form);
    })
    .then(function() {
      resetBtn();
    })
    .catch(function(error) {
      if (!error || !error.handled) {
        console.error('Error adding to cart:', error);
        const errorMsg = (error && (error.description || error.message))
          || 'Produk gagal ditambahkan. Silakan coba lagi.';
        window.CartEngine.showAddToCartError(errorMsg);
      }
      resetBtn();
    });
  }

  document.addEventListener('submit', function(e) {
    if (!isProductAddForm(e.target)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    handleProductAddToCart(e.target);
  }, true);

  if (window.CartEngine) {
    window.CartEngine.fetchCartJson().then(syncAllForms);
  }
});